(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider-main"] && !Shopify.designMode) return;
  try {
    
  class HeroSliderMain extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.slides = Array.from(this.querySelectorAll('.hero-slider-main__slide'));
      this.slider = this.querySelector('.hero-slider-main__slides');
      this.progressContainer = this.querySelector('.hero-slider-main__progress');
      this.autoplay = this.dataset.autoplay === 'true';
      this.currentIndex = 0;
      this.rafId = null;
      this.startTime = null;
      this.progressBarIndex = 0;
      this.usingSlick = this.canUseSlick();
      this.progressTimeout = null;
      this.progressToken = 0;
      this.slickTick = null;
      this.slickStartTime = null;
      this.slickProgressIndex = 0;

      const bgColor = this.dataset.bgColor;
      if (bgColor) {
        this.style.setProperty('--section-bg', bgColor);
      }

      this.applySlideVars();
      this.bindNewTabButtons();
      this.buildProgress();
      if (this.usingSlick) {
        this.initSlick();
      } else {
        this.showSlide(0);
        if (this.autoplay) {
        }
        this.ensureSlickReady();
      }

      window.addEventListener('resize', () => {
        if (this.usingSlick) {
          this.syncSlickHeight(this.currentIndex);
        } else {
          this.updateContainerHeight(this.currentIndex);
        }
      });

      this.classList.add('is-initialized');
    }

    applySlideVars() {
      this.slides.forEach((slide) => {
        const data = slide.dataset;
        const setPx = (value, name) => {
          if (value !== undefined && value !== '') {
            slide.style.setProperty(name, `${value}px`);
          }
        };
        const setVar = (value, name) => {
          if (value !== undefined && value !== '') {
            slide.style.setProperty(name, value);
          }
        };
        if (data.headingColor) {
          slide.style.setProperty('--heading-color', data.headingColor);
        }
        if (data.subheadingColor) {
          slide.style.setProperty('--subheading-color', data.subheadingColor);
        }
        if (data.descriptionColor) {
          slide.style.setProperty('--description-color', data.descriptionColor);
        }
        if (data.description2Color) {
          slide.style.setProperty('--description-2-color', data.description2Color);
        }
        if (data.description3Color) {
          slide.style.setProperty('--description-3-color', data.description3Color);
        }
        if (data.buttonBg) {
          slide.style.setProperty('--button-bg', data.buttonBg);
        }
        if (data.buttonText) {
          slide.style.setProperty('--button-text', data.buttonText);
        }
        setVar(data.riceHeadingColorMobile, '--rice-heading-color-mobile');
        setVar(data.riceSubheadingColorMobile, '--rice-subheading-color-mobile');
        setVar(data.riceBadgeBg, '--rice-badge-bg');
        setVar(data.riceBadgeText, '--rice-badge-text');
        setVar(data.riceBadgeTextMobile, '--rice-badge-text-mobile');
        setVar(data.riceBadgeBorder, '--rice-badge-border');
        setVar(data.tag1Bg, '--tag1-bg');
        setVar(data.tag1Text, '--tag1-text');
        setVar(data.tag1Border, '--tag1-border');
        setVar(data.tag2Bg, '--tag2-bg');
        setVar(data.tag2Text, '--tag2-text');
        setVar(data.tag2Border, '--tag2-border');
        setPx(data.tagMbDesktop, '--tag-mb-desktop');
        setPx(data.tagMbLaptop, '--tag-mb-laptop');
        setPx(data.tagMbTablet, '--tag-mb-tablet');
        setPx(data.tagMbMobile, '--tag-mb-mobile');
        setPx(data.headingSizeDesktop, '--heading-size-desktop');
        setPx(data.headingSizeLaptop, '--heading-size-laptop');
        setPx(data.headingSizeTablet, '--heading-size-tablet');
        setPx(data.headingSizeMobile, '--heading-size-mobile');
        if (data.headingMaxWidthEnableDesktop === 'true') {
          setPx(data.headingMaxWidthDesktop, '--heading-max-width-desktop');
        }
        if (data.headingMaxWidthEnableLaptop === 'true') {
          setPx(data.headingMaxWidthLaptop, '--heading-max-width-laptop');
        }
        if (data.headingMaxWidthEnableTablet === 'true') {
          setPx(data.headingMaxWidthTablet, '--heading-max-width-tablet');
        }
        setPx(data.subheadingSizeDesktop, '--subheading-size-desktop');
        setPx(data.subheadingSizeLaptop, '--subheading-size-laptop');
        setPx(data.subheadingSizeTablet, '--subheading-size-tablet');
        setPx(data.subheadingSizeMobile, '--subheading-size-mobile');
        setPx(data.descriptionSizeDesktop, '--description-size-desktop');
        setPx(data.descriptionSizeLaptop, '--description-size-laptop');
        setPx(data.descriptionSizeTablet, '--description-size-tablet');
        setPx(data.descriptionSizeMobile, '--description-size-mobile');
        setPx(data.description2SizeDesktop, '--description-2-size-desktop');
        setPx(data.description2SizeLaptop, '--description-2-size-laptop');
        setPx(data.description2SizeTablet, '--description-2-size-tablet');
        setPx(data.description2SizeMobile, '--description-2-size-mobile');
        setPx(data.description3SizeDesktop, '--description-3-size-desktop');
        setPx(data.description3SizeLaptop, '--description-3-size-laptop');
        setPx(data.description3SizeTablet, '--description-3-size-tablet');
        setPx(data.description3SizeMobile, '--description-3-size-mobile');
        setPx(data.subheadingMbDesktop, '--subheading-mb-desktop');
        setPx(data.subheadingMbLaptop, '--subheading-mb-laptop');
        setPx(data.subheadingMbTablet, '--subheading-mb-tablet');
        setPx(data.subheadingMbMobile, '--subheading-mb-mobile');
        setPx(data.headingMbDesktop, '--heading-mb-desktop');
        setPx(data.headingMbLaptop, '--heading-mb-laptop');
        setPx(data.headingMbTablet, '--heading-mb-tablet');
        setPx(data.headingMbMobile, '--heading-mb-mobile');
        setPx(data.descriptionMbDesktop, '--description-mb-desktop');
        setPx(data.descriptionMbLaptop, '--description-mb-laptop');
        setPx(data.descriptionMbTablet, '--description-mb-tablet');
        setPx(data.descriptionMbMobile, '--description-mb-mobile');
        setPx(data.description2MbDesktop, '--description-2-mb-desktop');
        setPx(data.description2MbLaptop, '--description-2-mb-laptop');
        setPx(data.description2MbTablet, '--description-2-mb-tablet');
        setPx(data.description2MbMobile, '--description-2-mb-mobile');
        setPx(data.description3MbDesktop, '--description-3-mb-desktop');
        setPx(data.description3MbLaptop, '--description-3-mb-laptop');
        setPx(data.description3MbTablet, '--description-3-mb-tablet');
        setPx(data.description3MbMobile, '--description-3-mb-mobile');
        setPx(data.buttonWidthDesktop, '--button-width-desktop');
        setPx(data.buttonWidthLaptop, '--button-width-laptop');
        setPx(data.buttonWidthTablet, '--button-width-tablet');
        setPx(data.buttonWidthMobile, '--button-width-mobile');
        setPx(data.buttonMbDesktop, '--button-mb-desktop');
        setPx(data.buttonMbLaptop, '--button-mb-laptop');
        setPx(data.buttonMbTablet, '--button-mb-tablet');
        setPx(data.buttonMbMobile, '--button-mb-mobile');
        setPx(data.heightDesktop, '--slide-height-desktop');
        setPx(data.heightLaptop, '--slide-height-laptop');
        setPx(data.heightTablet, '--slide-height-tablet');
        setPx(data.heightMobile, '--slide-height-mobile');
        setPx(data.overlayWidthDesktop, '--overlay-width-desktop');
        setPx(data.overlayHeightDesktop, '--overlay-height-desktop');
        setPx(data.overlayWidthLaptop, '--overlay-width-laptop');
        setPx(data.overlayHeightLaptop, '--overlay-height-laptop');
        setPx(data.overlayWidthTablet, '--overlay-width-tablet');
        setPx(data.overlayHeightTablet, '--overlay-height-tablet');
        setPx(data.overlayWidthMobile, '--overlay-width-mobile');
        setPx(data.overlayHeightMobile, '--overlay-height-mobile');
        setPx(data.overlayTopMobile, '--overlay-top-mobile');
      });
    }

    bindNewTabButtons() {
      const buttons = Array.from(this.querySelectorAll('.hero-slider-main__button'));
      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          const openNewTab = button.dataset.openNewTab === 'true';
          if (!openNewTab) return;
          event.preventDefault();
          const href = button.getAttribute('href');
          if (!href) return;
          window.open(href, '_blank', 'noopener');
        });
      });
    }

    getSlides() {
      return Array.from(this.querySelectorAll('.hero-slider-main__slide:not(.slick-cloned)'));
    }

    getDurationFromSlide(slide) {
      const duration = parseFloat(slide?.dataset?.duration || '5');
      return Math.max(1, duration) * 1000;
    }

    normalizeIndex(index) {
      const total = this.getSlides().length;
      if (!total) return 0;
      return ((index % total) + total) % total;
    }

    buildProgress() {
      if (!this.progressContainer) return;
      this.progressContainer.innerHTML = '';
      this.slides.forEach((_, index) => {
        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'hero-slider-main__progress-item';
        item.setAttribute('aria-label', `Go to slide ${index + 1}`);
        const fill = document.createElement('span');
        fill.className = 'hero-slider-main__progress-fill';
        item.appendChild(fill);
        item.addEventListener('click', () => {
  if (this.usingSlick) {
    this.goToSlick(index);
  } else {
    this.stop();
    this.resetProgress();

    requestAnimationFrame(() => {
      this.showSlide(index);
    });
  }
});

        this.progressContainer.appendChild(item);
      });
    }

    showSlide(index) {
  this.currentIndex = index;

  // âœ… FIX 1: progress visibility FIRST
  this.updateProgressVisibility(this.slides[index]);

  this.slides.forEach((slide, i) => {
    slide.classList.toggle('is-active', i === index);
  });

  // âœ… FIX 2: reset after visibility decision
  this.resetProgress();
  this.updateContainerHeight(index);

  if (!this.usingSlick && this.autoplay) {
    this.stop();
    const currentSlide = this.slides[index];
    this.waitForSlideReady(currentSlide).then(() => {
      if (this.currentIndex !== index) return;

      // âœ… extra safety
      if (
        this.dataset.progressDesktop === 'false' &&
        this.dataset.progressTablet === 'false' &&
        this.dataset.progressMobile === 'false'
      ) return;

      this.start();
    });
  }
}


    getDuration() {
      const slides = this.getSlides();
      const slide = slides[this.currentIndex];
      return this.getDurationFromSlide(slide);
    }

    getDurationForIndex(index) {
      const slides = this.getSlides();
      const slide = slides[index];
      return this.getDurationFromSlide(slide);
    }

    start() {
  this.startTime = null; // âœ… IMPORTANT

  const tick = (now) => {
    if (this.startTime === null) {
      this.startTime = now; // âœ… start counting from THIS frame
    }

    const elapsed = now - this.startTime;
    const duration = this.getDuration();
    const progress = Math.min(elapsed / duration, 1);

    this.updateProgress(progress);

    if (progress >= 1) {
      this.next();
    } else {
      this.rafId = requestAnimationFrame(tick);
    }
  };

  this.rafId = requestAnimationFrame(tick);
}


    pause() {
      if (this.usingSlick) {
        this.stopSlickProgress();
        return;
      }
      if (!this.rafId) return;
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
      this.pauseElapsed = performance.now() - this.startTime;
    }

    resume() {
      if (this.usingSlick) {
        this.startSlickProgress();
        return;
      }
      if (this.rafId || !this.autoplay) return;
      this.startTime = performance.now() - (this.pauseElapsed || 0);
      this.pauseElapsed = 0;
      this.start();
    }

    restart() {
        this.resetProgress();
      if (this.usingSlick) {
        this.restartSlickProgress();
        return;
      }

    }

    stop() {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
      if (this.usingSlick) {
        this.stopSlickProgress();
      }
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.showSlide(nextIndex);
    }

    resetProgress() {
  if (!this.progressContainer) return;

  const fills = this.progressContainer.querySelectorAll('.hero-slider-main__progress-fill');

  fills.forEach((fill, i) => {
    if (i !== this.currentIndex) {
      fill.style.width = '0%';
    }
  });

  // âœ… HARD reset active bar (same frame)
  const active = fills[this.currentIndex];
  if (active) {
    active.style.transition = 'none';
    active.style.width = '0%';
  }
}




    updateProgress(progress) {
      if (!this.progressContainer) return;
      const fills = this.progressContainer.querySelectorAll('.hero-slider-main__progress-fill');
      const active = fills[this.currentIndex];
      if (active) {
        active.style.width = `${progress * 100}%`;
      }
    }

    updateContainerHeight(index) {
      if (!this.slider || !this.slides[index]) return;
      this.slider.style.height = `${this.slides[index].offsetHeight}px`;
    }

    getSlideHeightForBreakpoint(slide) {
      if (!slide) return null;
      const width = window.innerWidth;
      if (width <= 767) return parseFloat(slide.dataset.heightMobile || '');
      if (width <= 1024) return parseFloat(slide.dataset.heightTablet || '');
      if (width <= 1399) return parseFloat(slide.dataset.heightLaptop || slide.dataset.heightDesktop || '');
      return parseFloat(slide.dataset.heightDesktop || '');
    }

    syncSlickHeight(index) {
      if (!this.slider) return;
      const slides = this.getSlides();
      const slide = slides[index];
      if (!slide) return;
      const height = this.getSlideHeightForBreakpoint(slide);
      if (!height) return;
      this.slider.style.height = `${height}px`;
      const slickList = this.slider.querySelector('.slick-list');
      const slickTrack = this.slider.querySelector('.slick-track');
      if (slickList) {
        slickList.style.height = `${height}px`;
      }
      if (slickTrack) {
        slickTrack.style.height = `${height}px`;
      }
      this.slider.querySelectorAll('.slick-slide').forEach((slickSlide) => {
        slickSlide.style.height = `${height}px`;
      });
    }

    ensureSlickReady() {
      let attempts = 0;
      const tryInit = () => {
        attempts += 1;
        if (this.usingSlick || attempts > 20) return;
        if (this.canUseSlick()) {
          this.usingSlick = true;
          this.stop();
          this.resetProgress();
          this.initSlick();
          return;
        }
        window.setTimeout(tryInit, 200);
      };
      window.setTimeout(tryInit, 200);
    }

    canUseSlick() {
      return !!(window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === 'function');
    }

    initSlick() {
      if (!this.slider) return;
      this.stop();
      this.resetProgress();
      const $slider = window.jQuery(this.slider);
      if ($slider.hasClass('slick-initialized')) return;
      this.$slider = $slider;

      $slider.slick({
        infinite: true,
        arrows: false,
        dots: false,
        autoplay: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
      });

      $slider.on('afterChange', (_event, _slick, currentSlide) => {
        this.handleSlickChange(currentSlide);
      });
      $slider.on('beforeChange', (_event, _slick, _currentSlide, nextSlide) => {
        this.currentIndex = this.normalizeIndex(nextSlide);
        this.stopSlickProgress();
        this.resetProgress();
        this.syncSlickHeight(this.currentIndex);
      });

      this.handleSlickChange(0);
      this.syncSlickHeight(0);

      if (this.autoplay) {
        const slides = this.getSlides();
        this.queueSlickProgress(slides[0]);
      }
    }

    handleSlickChange(index) {
      const normalized = this.normalizeIndex(index);
      this.currentIndex = normalized;
      this.progressBarIndex = normalized;
      const slides = this.getSlides();
      this.updateProgressVisibility(slides[normalized]);
      this.stopSlickProgress();
      this.resetProgress();
      this.syncSlickHeight(normalized);
      this.queueSlickProgress(slides[normalized]);
    }

    updateProgressVisibility(slide) {
  if (!this.progressContainer) return;
  const desktop = slide?.dataset?.progressDesktop ?? 'true';
  const tablet = slide?.dataset?.progressTablet ?? 'true';
  const mobile = slide?.dataset?.progressMobile ?? 'true';
  this.dataset.progressDesktop = desktop;
  this.dataset.progressTablet = tablet;
  this.dataset.progressMobile = mobile;
}

    waitForSlideReady(slide) {
      if (!slide) return Promise.resolve();
      const isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024;
      const isDesktop = window.innerWidth >= 1025;
      const selector = isDesktop
        ? '.hero-slider-main__media-img--desktop'
        : isTablet
          ? '.hero-slider-main__media-img--tablet'
          : '.hero-slider-main__media-img--mobile';
      const images = Array.from(slide.querySelectorAll(selector));
      if (!images.length) return Promise.resolve();
      images.forEach((img) => {
        if (img.loading === 'lazy') {
          img.loading = 'eager';
        }
      });
      const loaders = images.map((img) => {
        if (img.complete && img.naturalWidth > 0) return Promise.resolve();
        return new Promise((resolve) => {
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true });
        });
      });
      const timeout = new Promise((resolve) => window.setTimeout(resolve, 1500));
      return Promise.race([Promise.all(loaders), timeout]).then(() => undefined);
    }

    queueSlickProgress(slide) {
      if (!this.autoplay) return;
      this.waitForSlideReady(slide).then(() => {
        const slides = this.getSlides();
        if (slide !== slides[this.currentIndex]) return;
        this.startSlickProgress();
      });
    }

    goToSlick(index) {
      if (!this.slider) return;
      const $slider = window.jQuery(this.slider);
      $slider.slick('slickGoTo', index, false);
      this.handleSlickChange(index);
    }

    startSlickProgress() {
      if (!this.autoplay) return;
      this.stopSlickProgress();
      this.resetProgress();
      const slides = this.getSlides();
      const startIndex = this.currentIndex;
      const slide = slides[startIndex];
      const duration = this.getDurationFromSlide(slide);
      if (!duration) return;
      this.slickProgressIndex = startIndex;
      this.slickStartTime = Date.now();
      const tickId = window.setInterval(() => {
        if (this.currentIndex !== startIndex) {
          window.clearInterval(tickId);
          return;
        }
        const elapsed = Date.now() - (this.slickStartTime || Date.now());
        const percent = Math.min((elapsed / duration) * 100, 100);
        const fills = this.progressContainer?.querySelectorAll('.hero-slider-main__progress-fill');
        const active = fills?.[startIndex];
        if (active) {
          active.style.width = `${percent}%`;
        }
        if (percent >= 100 && this.slider) {
          this.resetProgress();
          this.$slider?.slick('slickNext');
        }
      }, 10);
      this.slickTick = tickId;
    }

    restartSlickProgress() {
      if (!this.autoplay) return;
      this.startSlickProgress();
    }

    stopSlickProgress() {
      this.progressToken += 1;
      if (this.slickTick) {
        window.clearInterval(this.slickTick);
        this.slickTick = null;
      }
      if (this.progressTick) {
        window.clearInterval(this.progressTick);
        this.progressTick = null;
      }
      if (this.progressTimeout) {
        window.clearTimeout(this.progressTimeout);
        this.progressTimeout = null;
      }
    }
  }

  customElements.define('hero-slider-main', HeroSliderMain);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-about-bundle"] && !Shopify.designMode) return;
  try {
    
    (function() {
      if (!document.querySelector('pdp-about-bundle')) return;
      if (typeof window.__PDP_ABOUT_BUNDLE_DEBUG__ === 'undefined') {
        window.__PDP_ABOUT_BUNDLE_DEBUG__ = false;
      }
      class PdpAboutBundle extends HTMLElement {
        debugLog(step, payload) {
          if (!window.__PDP_ABOUT_BUNDLE_DEBUG__) return;
          const sectionId = this?.dataset?.sectionId || 'unknown';
          if (typeof payload === 'undefined') {
            console.log(`[PDP About Bundle][${sectionId}] ${step}`);
            return;
          }
          console.log(`[PDP About Bundle][${sectionId}] ${step}`, payload);
        }

        getSwiperSnapshot(label) {
          if (!this.swiper) {
            return {
              label: label,
              hasSwiper: false
            };
          }
          const snapGrid = Array.isArray(this.swiper.snapGrid) ? this.swiper.snapGrid : [];
          return {
            label: label,
            hasSwiper: true,
            activeIndex: this.swiper.activeIndex,
            realIndex: this.swiper.realIndex,
            previousIndex: this.swiper.previousIndex,
            isBeginning: this.swiper.isBeginning,
            isEnd: this.swiper.isEnd,
            animating: this.swiper.animating,
            translate: this.swiper.translate,
            progress: this.swiper.progress,
            loopedSlides: this.swiper.loopedSlides,
            loopParam: this.swiper?.params?.loop,
            slidesPerGroup: this.swiper?.params?.slidesPerGroup,
            snapGridLength: snapGrid.length,
            snapGrid: snapGrid
          };
        }

        connectedCallback() {
          if (this.__initialized) return;
          this.__initialized = true;
          this.debugLog('connectedCallback:start', {
            sectionId: this.dataset.sectionId
          });

          this.handleCardClick = this.handleCardClick.bind(this);
          this.handleTrackClick = this.handleTrackClick.bind(this);
          this.handleSwiperChange = this.handleSwiperChange.bind(this);
          this.handlePrev = this.handlePrev.bind(this);
          this.handleNext = this.handleNext.bind(this);
          this.handleResize = this.handleResize.bind(this);
          this.handleAccordionToggle = this.handleAccordionToggle.bind(this);
          this.handleCtaClick = this.handleCtaClick.bind(this);
          this.handleExternalUpdate = this.handleExternalUpdate.bind(this);
          this.handleAddSubmit = this.handleAddSubmit.bind(this);

          this.init();
          this.debugLog('connectedCallback:after-init', {
            cards: this.cards ? this.cards.length : 0
          });
          window.addEventListener('resize', this.handleResize);
          document.addEventListener('variant:change', this.handleExternalUpdate);
          document.addEventListener('variantChanged', this.handleExternalUpdate);
          document.addEventListener('shopify:section:load', this.handleExternalUpdate);
          document.addEventListener('shopify:section:select', this.handleExternalUpdate);
        }

        disconnectedCallback() {
          if (!this.__initialized) return;
          this.__initialized = false;

          window.removeEventListener('resize', this.handleResize);
          document.removeEventListener('variant:change', this.handleExternalUpdate);
          document.removeEventListener('variantChanged', this.handleExternalUpdate);
          document.removeEventListener('shopify:section:load', this.handleExternalUpdate);
          document.removeEventListener('shopify:section:select', this.handleExternalUpdate);
          this.teardown();
        }

        init() {
          this.debugLog('init:start');
          this.teardown();

          this.track = this.querySelector('[data-bundle-track]');
          if (this.track && !this.originalTrackMarkup) {
            this.originalTrackMarkup = this.track.innerHTML;
          }
          if (this.track && this.originalTrackMarkup) {
            this.track.innerHTML = this.originalTrackMarkup;
          }
          this.cards = Array.from(this.querySelectorAll('[data-bundle-card]'));
          this.originalCardCount = this.cards.length;
          this.virtualLoopEnabled = false;
          this.virtualBaseCount = this.originalCardCount;
          this.virtualStartIndex = 0;
          this.prevButton = this.querySelector('[data-bundle-prev]');
          this.nextButton = this.querySelector('[data-bundle-next]');
          this.dotsViewport = this.querySelector('[data-bundle-dots-viewport]');
          this.dotsWrap = this.querySelector('[data-bundle-dots]');
          this.detailImage = this.querySelector('[data-detail-image]');
          this.detailTitle = this.querySelector('[data-detail-title]');
          this.detailHighlight = this.querySelector('[data-detail-highlight]');
          this.cookingContent = this.querySelector('[data-cooking-content]');
          this.nutritionContent = this.querySelector('[data-nutrition-content]');
          this.accordions = Array.from(this.querySelectorAll('.pdp-about-bundle__accordion'));
          this.accordionToggles = Array.from(this.querySelectorAll('[data-accordion-toggle]'));
          this.form = this.querySelector('.pdp-about-bundle__form');
          this.addButtons = Array.from(this.querySelectorAll('.pdp-about-bundle__add'));
          this.variantInput = this.querySelector('[data-about-bundle-variant]');
          this.cardDataMap = this.getCardDataMap();
          this.canLoopSlides = false;
          this.debugLog('init:refs-ready', {
            hasTrack: Boolean(this.track),
            cards: this.cards.length,
            hasPrev: Boolean(this.prevButton),
            hasNext: Boolean(this.nextButton)
          });

          const hasCards = this.track && this.cards.length > 0;

          if (hasCards) {
            this.track.addEventListener('click', this.handleTrackClick);
            if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
            if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);
          }
          if (this.accordionToggles.length) {
            this.accordionToggles.forEach((toggle) => toggle.addEventListener('click', this.handleAccordionToggle));
          }

          const ctaButton = this.querySelector('[data-scroll-target]');
          if (ctaButton) ctaButton.addEventListener('click', this.handleCtaClick);
          if (this.form) this.form.addEventListener('submit', this.handleAddSubmit);

          if (hasCards) {
            this.buildDots();
            if (this.dotsViewport) {
              this.dotsViewport.scrollLeft = 0;
            }
            this.setActiveCardByIndex(0);
            this.initSwiper();
          } else {
            this.updateNavButtons();
          }

          this.resetAddButtons();
          this.setupCartHooks();
          this.debugLog('init:end', {
            hasCards: Boolean(hasCards),
            pageCount: this.pageCount || 0
          });
        }

        teardown() {
          if (this.swiper) {
            this.swiper.off('slideChange', this.handleSwiperChange);
            this.swiper.off('resize', this.handleSwiperChange);
            this.swiper.destroy(true, true);
            this.swiper = null;
          }

          if (this.track) {
            this.track.removeEventListener('click', this.handleTrackClick);
          }
          if (this.prevButton) this.prevButton.removeEventListener('click', this.handlePrev);
          if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
          if (this.accordionToggles && this.accordionToggles.length) {
            this.accordionToggles.forEach((toggle) => toggle.removeEventListener('click', this.handleAccordionToggle));
          }

          const ctaButton = this.querySelector('[data-scroll-target]');
          if (ctaButton) ctaButton.removeEventListener('click', this.handleCtaClick);
          if (this.form) this.form.removeEventListener('submit', this.handleAddSubmit);
        }

        handleExternalUpdate(event) {
          if (event && event.detail && event.detail.sectionId && event.detail.sectionId !== this.dataset.sectionId) {
            return;
          }
          if (event && event.detail) {
            const variantId = event.detail.variantId;
            const variantAvailable = event.detail.variantAvailable;
            this.updateCtaState(variantId, variantAvailable);
          }
          window.requestAnimationFrame(() => this.init());
        }

        decodeHtml(value) {
          if (!value) return '';
          const textarea = document.createElement('textarea');
          textarea.innerHTML = value;
          return textarea.value;
        }

        normalizeHtml(value) {
          if (!value) return '';
          let html = String(value);
          html = html.replace(/>\s*<br\s*\/?>\s*</gi, '><');
          html = html.replace(/<([a-z0-9]+)([^>]*)>\s*<br\s*\/?>/gi, '<$1$2>');
          html = html.replace(/<br\s*\/?>\s*<\/([a-z0-9]+)>/gi, '</$1>');
          html = html.replace(/^\s*(<br\s*\/?>\s*)+/i, '');
          html = html.replace(/(<br\s*\/?>\s*)+$/i, '');
          html = html.replace(/(<br\s*\/?>\s*){2,}/gi, '<br>');
          html = html.replace(/<p>\s*<\/p>/gi, '');
          html = html.replace(/<p>\s*(<br\s*\/?>\s*)+\s*<\/p>/gi, '');
          return html;
        }

        getCardDataMap() {
          const script = this.querySelector('[data-bundle-data]');
          if (!script) return {};
          try {
            const data = JSON.parse(script.textContent || '[]');
            const map = {};
            data.forEach((item) => {
              if (item && item.id != null) {
                map[String(item.id)] = item;
              }
            });
            return map;
          } catch (error) {
            return {};
          }
        }

        ensureSwiperLibrary() {
          if (typeof window.Swiper !== 'undefined') {
            return Promise.resolve(window.Swiper);
          }
          if (window.__pdpAboutBundleSwiperPromise) {
            return window.__pdpAboutBundleSwiperPromise;
          }
          window.__pdpAboutBundleSwiperPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
            script.async = true;
            script.onload = () => resolve(window.Swiper);
            script.onerror = () => reject(new Error('Failed to load Swiper'));
            document.head.appendChild(script);
          });
          return window.__pdpAboutBundleSwiperPromise;
        }

        initSwiper() {
          if (!this.track || !this.cards.length) {
            this.updateNavButtons();
            this.debugLog('initSwiper:skipped', {
              hasTrack: Boolean(this.track),
              cards: this.cards ? this.cards.length : 0
            });
            return;
          }

          this.ensureSwiperLibrary()
            .then(() => {
              if (!this.isConnected || !this.track || !this.cards.length) return;
              const totalCards = this.originalCardCount || this.cards.length;
              const visibleCards = Math.max(1, this.getSlidesPerGroup());
              const maxSafeGroup = Math.max(1, totalCards - visibleCards);
              const navStep = this.getNavigationStep(visibleCards, totalCards);
              const shouldLoop = totalCards > visibleCards;
              const useVirtualLoop = shouldLoop;
              const slidesPerView = 'auto';
              this.slidesPerGroup = navStep;
              this.canLoopSlides = useVirtualLoop;
              if (useVirtualLoop) {
                this.enableVirtualLoopSlides(totalCards);
              } else {
                this.cards = Array.from(this.querySelectorAll('[data-bundle-card]'));
              }
              this.debugLog('initSwiper:creating', {
                totalCards: totalCards,
                visibleCards: visibleCards,
                maxSafeGroup: maxSafeGroup,
                shouldLoop: shouldLoop,
                useVirtualLoop: useVirtualLoop,
                slidesPerView: slidesPerView,
                slidesPerGroup: 1,
                navStep: navStep,
                cards: this.cards.length
              });
              this.swiper = new Swiper(this.querySelector('[data-bundle-slider]'), {
                slidesPerView: slidesPerView,
                slidesPerGroup: 1,
                slidesPerGroupAuto: false,
                spaceBetween: 24,
                loop: false,
                oneWayMovement: true,
                loopAddBlankSlides: false,
                speed: 420,
                watchOverflow: false,
                allowTouchMove: true,
                observer: true,
                observeParents: true
              });
              this.querySelectorAll('.pdp-about-bundle__card.swiper-slide').forEach(function(btn) {
                btn.removeAttribute('role');
                btn.removeAttribute('aria-label');
              });
              if (useVirtualLoop && Number.isFinite(this.virtualStartIndex)) {
                this.swiper.slideTo(this.virtualStartIndex, 0, false);
              }
              this.debugLog('initSwiper:created', {
                nativeLoopActive: this.isNativeLoopActive(),
                loopedSlides: this.swiper ? this.swiper.loopedSlides : 0,
                virtualLoopEnabled: this.virtualLoopEnabled
              });
              this.debugLog('initSwiper:snapshot', this.getSwiperSnapshot('after-create'));

              this.swiper.on('slideChange', this.handleSwiperChange);
              this.swiper.on('resize', this.handleSwiperChange);
              this.swiper.on('beforeTransitionStart', (speed, internal) => {
                this.debugLog('swiper:event:beforeTransitionStart', {
                  speed: speed,
                  internal: internal,
                  snapshot: this.getSwiperSnapshot('beforeTransitionStart')
                });
              });
              this.swiper.on('transitionStart', () => {
                this.debugLog('swiper:event:transitionStart', this.getSwiperSnapshot('transitionStart'));
              });
              this.swiper.on('transitionEnd', () => {
                this.normalizeVirtualLoopPosition();
                this.debugLog('swiper:event:transitionEnd', this.getSwiperSnapshot('transitionEnd'));
              });
              this.swiper.on('reachEnd', () => {
                this.debugLog('swiper:event:reachEnd', this.getSwiperSnapshot('reachEnd'));
              });
              this.swiper.on('reachBeginning', () => {
                this.debugLog('swiper:event:reachBeginning', this.getSwiperSnapshot('reachBeginning'));
              });
              this.swiper.on('loopFix', () => {
                this.debugLog('swiper:event:loopFix', this.getSwiperSnapshot('loopFix'));
              });

              this.handleSwiperChange();
            })
            .catch(() => {
              this.canLoopSlides = false;
              this.updateNavButtons();
              this.debugLog('initSwiper:error');
            });
        }

        enableVirtualLoopSlides(totalCards) {
          if (!this.track || !totalCards) return;
          const baseSlides = Array.from(this.track.querySelectorAll('[data-bundle-card]'));
          if (!baseSlides.length) return;

          const fragment = document.createDocumentFragment();
          for (let copy = 0; copy < 3; copy += 1) {
            baseSlides.forEach((slide) => {
              const clone = slide.cloneNode(true);
              clone.setAttribute('data-virtual-copy', String(copy));
              fragment.appendChild(clone);
            });
          }
          this.track.innerHTML = '';
          this.track.appendChild(fragment);

          this.cards = Array.from(this.track.querySelectorAll('[data-bundle-card]'));
          this.virtualLoopEnabled = true;
          this.virtualBaseCount = totalCards;
          this.virtualStartIndex = totalCards;
        }

        isVirtualLoopMode() {
          return Boolean(this.virtualLoopEnabled && this.swiper && this.virtualBaseCount > 0);
        }

        normalizeVirtualLoopPosition() {
          if (!this.isVirtualLoopMode()) return;
          const base = this.virtualBaseCount;
          const active = Number(this.swiper.activeIndex || 0);

          if (active < base) {
            this.swiper.slideTo(active + base, 0, false);
            return;
          }
          if (active >= base * 2) {
            this.swiper.slideTo(active - base, 0, false);
          }
        }

        getNormalizedSwiperIndex() {
          if (!this.swiper) return 0;
          if (this.isVirtualLoopMode()) {
            const base = this.virtualBaseCount;
            const active = Number(this.swiper.activeIndex || 0);
            return ((active % base) + base) % base;
          }
          if (this.isNativeLoopActive()) {
            return Number(this.swiper.realIndex || 0);
          }
          return Number(this.swiper.activeIndex || 0);
        }

        getDirectionalVirtualTarget(targetNormalized, direction) {
          if (!this.isVirtualLoopMode() || !this.swiper) return targetNormalized;
          const base = Math.max(1, this.virtualBaseCount || 1);
          const active = Number(this.swiper.activeIndex || 0);
          const currentCopy = Math.floor(active / base);
          let target = (currentCopy * base) + Math.max(0, Math.min(base - 1, Number(targetNormalized || 0)));

          if (direction === 'next' && target <= active) {
            target += base;
          } else if (direction === 'prev' && target >= active) {
            target -= base;
          }

          const maxIndex = Math.max(0, (this.cards ? this.cards.length : base * 3) - 1);
          return Math.max(0, Math.min(maxIndex, target));
        }

        getSlidesPerGroup() {
          const slider = this.querySelector('[data-bundle-slider]');
          if (!slider || !this.cards || !this.cards.length) return 1;
          const firstCard = this.cards[0];
          const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 0;
          if (!cardWidth) return 1;
          const cardWithGap = cardWidth + 24;
          const visibleCards = Math.floor((slider.clientWidth + 24) / cardWithGap);
          return Math.max(1, visibleCards);
        }

        isTabletViewport() {
          const width = window.innerWidth || document.documentElement.clientWidth || 0;
          return width >= 768 && width <= 1024;
        }

        getNavigationStep(visibleCards, totalCards) {
          if (this.isTabletViewport()) {
            return Math.max(1, Math.min(3, totalCards || visibleCards || 1));
          }
          return Math.max(1, visibleCards || 1);
        }

        getBatchStartIndexes(step) {
          const totalCards = this.originalCardCount || 0;
          const visibleCards = Math.max(1, this.slidesPerGroup || this.getSlidesPerGroup());
          const maxStart = Math.max(0, totalCards - visibleCards);
          if (maxStart === 0) return [0];

          if (this.isTabletViewport() && totalCards >= 7) {
            const starts = [];
            for (let i = 0; i < totalCards; i += 1) {
              starts.push(i);
            }
            return starts;
          }

          const desiredDots = this.getDotsVisibleCount(totalCards);
          if (desiredDots <= 2) {
            return [0, maxStart];
          }

          const jump = Math.max(1, step || visibleCards);
          const naturalStarts = [];
          for (let start = 0; start <= maxStart; start += jump) {
            naturalStarts.push(start);
          }
          if (naturalStarts[naturalStarts.length - 1] !== maxStart) {
            naturalStarts.push(maxStart);
          }

          let middle = naturalStarts.length >= 3 ? naturalStarts[1] : Math.round(maxStart / 2);
          middle = Math.max(1, Math.min(maxStart - 1, middle));
          return Array.from(new Set([0, middle, maxStart]));
        }

        getNavStartIndexes(step) {
          const totalCards = this.originalCardCount || 0;
          const visibleCards = Math.max(1, this.getSlidesPerGroup());
          const maxStart = Math.max(0, totalCards - visibleCards);
          if (maxStart === 0) return [0];

          const jump = Math.max(1, step || this.slidesPerGroup || visibleCards);
          const starts = [];
          for (let start = 0; start <= maxStart; start += jump) {
            starts.push(start);
          }
          if (starts[starts.length - 1] !== maxStart) {
            starts.push(maxStart);
          }
          return starts;
        }

        getActiveBatchIndex(currentIndex, starts) {
          if (!starts || !starts.length) return 0;
          let activeBatch = 0;
          for (let i = 0; i < starts.length; i += 1) {
            if (currentIndex >= starts[i]) {
              activeBatch = i;
            } else {
              break;
            }
          }
          return activeBatch;
        }

        setActiveCardByIndex(index) {
          if (!this.cards || !this.cards.length) return;
          const safeIndex = Math.max(0, Math.min(index, this.cards.length - 1));
          this.setActiveCard(this.cards[safeIndex]);
        }

        setActiveCard(card) {
          if (!card) return;
          const selectedIndex = Number(card.getAttribute('data-card-index'));
          const allCards = Array.from(this.querySelectorAll('[data-bundle-card]'));
          allCards.forEach((item) => item.classList.remove('is-active'));
          if (Number.isFinite(selectedIndex)) {
            allCards.forEach((item) => {
              if (Number(item.getAttribute('data-card-index')) === selectedIndex) {
                item.classList.add('is-active');
              }
            });
          } else {
            card.classList.add('is-active');
          }

          const cardId = card.getAttribute('data-card-id');
          const cardData = cardId && this.cardDataMap ? this.cardDataMap[cardId] : null;
          if (!cardData) return;

          const title = cardData.title;
          const subtitle = cardData.subtitle;
          const image = cardData.image;
          const imageSrcset = cardData.imageSrcset;
          const imageSizes = cardData.imageSizes;
          const highlight = this.normalizeHtml(this.decodeHtml(cardData.highlight));
          const cooking = this.normalizeHtml(this.decodeHtml(cardData.cooking));
          const nutrition = this.normalizeHtml(this.decodeHtml(cardData.nutrition));

          const highlightTitle = this.querySelector('[data-highlight-title]');

          if (this.detailTitle) {
            this.detailTitle.textContent = title || '';
          }

          if (this.detailImage && image) {
            this.detailImage.src = image;
            if (title) this.detailImage.alt = title;
          }

          if (this.detailImage && imageSrcset) {
            this.detailImage.setAttribute('srcset', imageSrcset);
          } else if (this.detailImage) {
            this.detailImage.removeAttribute('srcset');
          }

          if (this.detailImage && imageSizes) {
            this.detailImage.setAttribute('sizes', imageSizes);
          } else if (this.detailImage) {
            this.detailImage.removeAttribute('sizes');
          }

          if (this.detailHighlight) {
            this.detailHighlight.innerHTML = highlight || '';
          }

          if (highlightTitle) {
            highlightTitle.style.display = highlight ? '' : 'none';
          }

          if (this.cookingContent) {
            this.cookingContent.innerHTML = cooking || '';
          }

          if (this.nutritionContent) {
            this.nutritionContent.innerHTML = nutrition || '';
          }
          if (this.accordions && this.accordions.length) {
            const visibleAccordions = [];
            this.accordions.forEach((accordion) => {
              const isCooking = Boolean(accordion.querySelector('[data-cooking-content]'));
              const hasContent = isCooking ? cooking : nutrition;
              accordion.style.display = hasContent ? '' : 'none';
              accordion.classList.remove('is-not-last');

              const shouldOpen = Boolean(hasContent && accordion.dataset.defaultOpen === 'true');
              this.setAccordionState(accordion, shouldOpen);

              if (hasContent) {
                visibleAccordions.push(accordion);
              }
            });

            if (visibleAccordions.length > 1) {
              visibleAccordions.slice(0, -1).forEach((accordion) => {
                accordion.classList.add('is-not-last');
              });
            }
          }

          if (subtitle && this.detailTitle) {
            this.detailTitle.dataset.subtitle = subtitle;
          }

          this.updateDots();
        }

        handleCardClick(event) {
          const card = event && event.currentTarget ? event.currentTarget : null;
          if (!card) return;
          this.setActiveCard(card);
        }

        handleTrackClick(event) {
          const card = event.target ? event.target.closest('[data-bundle-card]') : null;
          if (!card || !this.track || !this.track.contains(card)) return;
          this.handleCardClick({ currentTarget: card });
        }

        handleSwiperChange() {
          if (!this.cards || this.cards.length === 0) return;
          const activeIndex = this.getNormalizedSwiperIndex();
          this.debugLog('handleSwiperChange', {
            activeIndex: activeIndex,
            swiperActiveIndex: this.swiper ? this.swiper.activeIndex : null,
            snapshot: this.getSwiperSnapshot('slideChange')
          });
          this.updateNavButtons();
          this.updateDots();
        }

        isNativeLoopActive() {
          if (!this.swiper) return false;
          if (!this.swiper.params || !this.swiper.params.loop) return false;
          return Number(this.swiper.loopedSlides || 0) > 0;
        }

        slideByStep(direction, step) {
          if (!this.swiper) return;
          const moves = Math.max(1, step || 1);
          const perSlideSpeed = 300;
          if (direction === 'next') {
            this.swiper.slideTo((this.swiper.activeIndex || 0) + moves, perSlideSpeed * 2, true);
          } else {
            this.swiper.slideTo(Math.max(0, (this.swiper.activeIndex || 0) - moves), perSlideSpeed * 2, true);
          }
        }

        getDotsVisibleCount(totalDots) {
          const dotsTotal = Number(totalDots || 0);
          if (!dotsTotal) return 0;
          if (this.isTabletViewport()) {
            return Math.min(3, dotsTotal);
          }
          const threshold = 12;
          const maxVisible = (this.originalCardCount || dotsTotal) >= threshold ? 3 : 2;
          return Math.min(maxVisible, dotsTotal);
        }

        applyDotsViewportWidth(totalDots) {
          if (!this.dotsViewport) return;
          const visibleCount = this.getDotsVisibleCount(totalDots);
          this.dotsViewport.classList.toggle('is-two-visible', visibleCount === 2);
        }

        buildDots() {
          if (!this.dotsWrap) return;
          this.dotsWrap.innerHTML = '';
          this.batchStarts = this.getBatchStartIndexes(this.slidesPerGroup || this.getSlidesPerGroup());
          this.pageCount = this.batchStarts.length;
          this.dotsWindowStart = 0;
          this.dotsWindowLock = false;
          this.applyDotsViewportWidth(this.pageCount);

          for (let i = 0; i < this.pageCount; i += 1) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'pdp-about-bundle__dot' + (i === 0 ? ' is-active' : '');
            dot.setAttribute('data-page', String(i));
            dot.addEventListener('click', () => {
              const dots = Array.from(this.dotsWrap.children);
              const visibleCount = this.getDotsVisibleCount(this.originalCardCount || dots.length);
              const maxStart = Math.max(0, dots.length - visibleCount);
              if (typeof this.dotsWindowStart !== 'number') {
                this.dotsWindowStart = 0;
              }
              if (visibleCount > 1 && i === this.dotsWindowStart + visibleCount - 1 && this.dotsWindowStart < maxStart) {
                this.dotsWindowStart = Math.min(maxStart, i);
                this.dotsWindowLock = true;
              }
              const starts = this.batchStarts && this.batchStarts.length ? this.batchStarts : this.getBatchStartIndexes(this.slidesPerGroup || 1);
              const targetStart = starts[Math.max(0, Math.min(i, starts.length - 1))] || 0;
              if (this.swiper) {
                if (this.isVirtualLoopMode()) {
                  const direction = targetStart >= this.getNormalizedSwiperIndex() ? 'next' : 'prev';
                  const targetIndex = this.getDirectionalVirtualTarget(targetStart, direction);
                  this.swiper.slideTo(targetIndex, 900, true);
                } else if (this.isNativeLoopActive()) {
                  this.swiper.slideToLoop(targetStart);
                } else {
                  this.swiper.slideTo(targetStart);
                }
              }
              this.setActiveCardByIndex(targetStart);
              this.scrollDotsToIndex(i, visibleCount, this.dotsWindowStart);
            });
            this.dotsWrap.appendChild(dot);
          }

          this.updateDots();
        }

        updateNavButtons() {
          const totalCards = this.originalCardCount || (this.cards ? this.cards.length : 0);
          const visibleCards = Math.max(1, this.getSlidesPerGroup());
          const canSlide = Boolean(this.swiper && totalCards > visibleCards);
          const shouldDisable = !canSlide;

          if (this.prevButton) {
            this.prevButton.disabled = shouldDisable;
          }
          if (this.nextButton) {
            this.nextButton.disabled = shouldDisable;
          }
        }

        updateDots() {
          if (!this.dotsWrap || !this.pageCount) return;
          if (this.isUpdatingDots) return;
          const starts = this.batchStarts && this.batchStarts.length ? this.batchStarts : this.getBatchStartIndexes(this.slidesPerGroup || 1);
          const currentPage = this.getActiveBatchIndex(this.getActiveIndex(), starts);
          const dots = Array.from(this.dotsWrap.children);
          const visibleCount = this.getDotsVisibleCount(this.originalCardCount || dots.length);
          const maxStart = Math.max(0, dots.length - visibleCount);
          let startIndex = 0;
          if (!this.dotsWindowLock) {
            startIndex = Math.min(maxStart, Math.max(0, currentPage - 1));
          } else if (typeof this.dotsWindowStart === 'number') {
            startIndex = this.dotsWindowStart;
          }
          startIndex = Math.min(maxStart, Math.max(0, startIndex));
          if (currentPage < startIndex) {
            startIndex = currentPage;
          } else if (currentPage > startIndex + visibleCount - 1) {
            startIndex = Math.min(maxStart, currentPage - (visibleCount - 1));
          }
          this.dotsWindowStart = startIndex;
          this.dotsWindowLock = false;
          dots.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === currentPage);
          });
          this.scrollDotsToIndex(currentPage, visibleCount, startIndex);
        }

        scrollDotsToIndex(index, visibleCountOverride, startIndexOverride) {
          if (!this.dotsViewport || !this.dotsWrap) return;
          const dots = Array.from(this.dotsWrap.children);
          const dot = dots[index];
          if (!dot) return;
          const visibleCount = visibleCountOverride || this.getDotsVisibleCount(dots.length);
          if (visibleCount <= 1) {
            this.dotsViewport.scrollTo({ left: 0, behavior: 'auto' });
            return;
          }

          const secondDot = dots[1];
          const step = secondDot ? Math.max(0, secondDot.offsetLeft - dots[0].offsetLeft) : dot.offsetWidth;
          const maxStart = Math.max(0, dots.length - visibleCount);
          let startIndex = typeof startIndexOverride === 'number' ? startIndexOverride : Math.min(maxStart, Math.max(0, index - 1));
          startIndex = Math.min(maxStart, Math.max(0, startIndex));
          const targetLeft = step * startIndex;
          this.isUpdatingDots = true;
          this.dotsViewport.scrollTo({
            left: Math.max(0, targetLeft),
            behavior: 'smooth'
          });
          clearTimeout(this.dotsUpdateTimeout);
          this.dotsUpdateTimeout = setTimeout(() => {
            this.isUpdatingDots = false;
          }, 350);
        }

        handlePrev() {
          this.debugLog('handlePrev:click', {
            hasSwiper: Boolean(this.swiper),
            isDisabled: Boolean(this.prevButton && this.prevButton.disabled),
            snapshot: this.getSwiperSnapshot('before-prev')
          });
          if (!this.swiper || this.prevButton?.disabled) return;
          const cardCount = this.cards ? this.cards.length : 0;
          if (cardCount <= 1) return;
          const step = Math.max(1, Math.min(this.slidesPerGroup || 1, cardCount - 1));
          const isVirtualMode = this.isVirtualLoopMode();
          const isLoopMode = this.isNativeLoopActive();
          const currentActiveIndex = Number(this.swiper.activeIndex || 0);
          const currentRealIndex = Number(this.swiper.realIndex || 0);

          this.debugLog('handlePrev:navigate', {
            mode: isVirtualMode ? 'virtual-loop' : (isLoopMode ? 'loop-native-group' : 'fallback-slide'),
            step: step,
            currentActiveIndex: currentActiveIndex,
            currentRealIndex: currentRealIndex,
            targetActiveIndex: currentActiveIndex - step
          });

          if (isVirtualMode) {
            const currentNormalized = this.getNormalizedSwiperIndex();
            const starts = this.getNavStartIndexes(step);
            let prevStart = starts[starts.length - 1];
            for (let i = starts.length - 1; i >= 0; i -= 1) {
              if (starts[i] < currentNormalized) {
                prevStart = starts[i];
                break;
              }
            }
            const targetIndex = this.getDirectionalVirtualTarget(prevStart, 'prev');
            this.swiper.slideTo(targetIndex, 900, true);
            return;
          }

          if (isLoopMode) {
            this.swiper.slideTo(currentActiveIndex - step, 900, true);
            return;
          }

          this.swiper.slidePrev(900, true);
        }

        handleNext() {
          this.debugLog('handleNext:click', {
            hasSwiper: Boolean(this.swiper),
            isDisabled: Boolean(this.nextButton && this.nextButton.disabled),
            snapshot: this.getSwiperSnapshot('before-next')
          });
          if (!this.swiper || this.nextButton?.disabled) return;
          const cardCount = this.cards ? this.cards.length : 0;
          if (cardCount <= 1) return;
          const step = Math.max(1, Math.min(this.slidesPerGroup || 1, cardCount - 1));
          const isVirtualMode = this.isVirtualLoopMode();
          const isLoopMode = this.isNativeLoopActive();
          const currentActiveIndex = Number(this.swiper.activeIndex || 0);
          const currentRealIndex = Number(this.swiper.realIndex || 0);

          this.debugLog('handleNext:navigate', {
            mode: isVirtualMode ? 'virtual-loop' : (isLoopMode ? 'loop-native-group' : 'fallback-slide'),
            step: step,
            currentActiveIndex: currentActiveIndex,
            currentRealIndex: currentRealIndex,
            targetActiveIndex: currentActiveIndex + step
          });

          if (isVirtualMode) {
            const currentNormalized = this.getNormalizedSwiperIndex();
            const starts = this.getNavStartIndexes(step);
            const nextStart = starts.find((start) => start > currentNormalized);
            const targetStart = typeof nextStart === 'number' ? nextStart : starts[0];
            const targetIndex = this.getDirectionalVirtualTarget(targetStart, 'next');
            this.swiper.slideTo(targetIndex, 900, true);
            return;
          }

          if (isLoopMode) {
            this.swiper.slideTo(currentActiveIndex + step, 900, true);
            return;
          }

          this.swiper.slideNext(900, true);
        }

        handleResize() {
          window.requestAnimationFrame(() => this.init());
        }

        setAccordionState(accordion, isOpen) {
          if (!accordion) return;
          const panel = accordion.querySelector('[data-accordion-panel]');
          const toggle = accordion.querySelector('[data-accordion-toggle]');
          if (!panel || !toggle) return;

          accordion.classList.toggle('is-open', isOpen);
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

          if (isOpen) {
            panel.hidden = false;
            panel.style.maxHeight = panel.scrollHeight + 'px';
          } else {
            panel.style.maxHeight = '0px';
            clearTimeout(accordion.__closeTimeout);
            accordion.__closeTimeout = setTimeout(() => {
              panel.hidden = true;
            }, 300);
          }
        }

        handleAccordionToggle(event) {
          const toggle = event.currentTarget;
          const accordion = toggle ? toggle.closest('.pdp-about-bundle__accordion') : null;
          if (!accordion) return;
          const isOpen = !accordion.classList.contains('is-open');
          this.setAccordionState(accordion, isOpen);
        }

        handleCtaClick(event) {
          const target = event.currentTarget.getAttribute('data-scroll-target');
          if (!target) return;
          const el = document.querySelector(target);
          if (el) {
            event.preventDefault();
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }

        handleAddSubmit() {
          if (!this.addButtons || this.addButtons.length === 0) return;
          this.addButtons.forEach((btn) => {
            if (btn.hasAttribute('disabled')) return;
            btn.textContent = btn.dataset.addingLabel || 'Adding...';
            btn.setAttribute('disabled', 'disabled');
            btn.classList.add('is-adding');
          });
        }

        updateCtaState(variantId, variantAvailable) {
          if (variantId && this.variantInput) {
            this.variantInput.value = variantId;
          }
          if (typeof variantAvailable === 'boolean') {
            this.currentVariantAvailable = variantAvailable;
          }
          if (!this.addButtons || this.addButtons.length === 0) return;

          this.addButtons.forEach((btn) => {
            btn.classList.remove('is-adding');
            if (this.currentVariantAvailable === false) {
              btn.setAttribute('disabled', 'disabled');
              btn.textContent = btn.dataset.outLabel || 'Out of stock';
            } else {
              btn.removeAttribute('disabled');
              btn.textContent = btn.dataset.addLabel || 'Add to cart';
            }
          });
        }

        resetAddButtons() {
          if (!this.addButtons || this.addButtons.length === 0) return;
          if (typeof this.currentVariantAvailable !== 'boolean' && this.addButtons[0]) {
            this.currentVariantAvailable = !this.addButtons[0].hasAttribute('disabled');
          }
          this.updateCtaState(null, this.currentVariantAvailable);
        }

        setupCartHooks() {
          if (!window.__pdpAboutBundleResetAddButtons) {
            window.__pdpAboutBundleResetAddButtons = () => {
              document.querySelectorAll('pdp-about-bundle').forEach((el) => {
                if (el && typeof el.resetAddButtons === 'function') {
                  el.resetAddButtons();
                }
              });
            };
          }

          if (!window.__pdpAboutBundleCartHooks) {
            window.__pdpAboutBundleCartHooks = true;

            const reset = window.__pdpAboutBundleResetAddButtons;
            document.addEventListener('cart:updated', reset);
            document.addEventListener('cart:refresh', reset);
            document.addEventListener('cart:change', reset);
            document.addEventListener('rebuy:cart:updated', reset);
            document.addEventListener('rebuy:cart:open', reset);

            const shouldResetForUrl = (url) => {
              if (!url) return false;
              return url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update');
            };

            const originalFetch = window.fetch;
            if (originalFetch && !window.__pdpAboutBundleFetchPatched) {
              window.__pdpAboutBundleFetchPatched = true;
              window.fetch = (...args) => {
                const responsePromise = originalFetch.apply(window, args);
                const requestUrl = typeof args[0] === 'string' ? args[0] : args[0]?.url;
                if (shouldResetForUrl(requestUrl)) {
                  responsePromise.then((response) => {
                    if (response && response.ok) {
                      reset();
                    }
                  }).catch(() => {});
                }
                return responsePromise;
              };
            }

            if (!window.__pdpAboutBundleXhrPatched) {
              window.__pdpAboutBundleXhrPatched = true;
              const originalOpen = XMLHttpRequest.prototype.open;
              const originalSend = XMLHttpRequest.prototype.send;

              XMLHttpRequest.prototype.open = function(method, url, ...rest) {
                this.__pdpAboutBundleUrl = url;
                return originalOpen.call(this, method, url, ...rest);
              };

              XMLHttpRequest.prototype.send = function(body) {
                this.addEventListener('load', () => {
                  if (shouldResetForUrl(this.__pdpAboutBundleUrl) && this.status >= 200 && this.status < 300) {
                    reset();
                  }
                });
                return originalSend.call(this, body);
              };
            }
          }
        }

        getActiveIndex() {
          if (this.swiper) {
            return this.getNormalizedSwiperIndex();
          }
          const activeCard = this.querySelector('.pdp-about-bundle__card.is-active');
          if (!activeCard) return 0;
          const activeIndexAttr = Number(activeCard.getAttribute('data-card-index'));
          return Number.isFinite(activeIndexAttr) ? activeIndexAttr : 0;
        }
      }

      if (!customElements.get('pdp-about-bundle')) {
        customElements.define('pdp-about-bundle', PdpAboutBundle);
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get("pdp-bundle")) {
    class PdpBundle extends HTMLElement {
      connectedCallback() {
        this.initQuantity();
        this.initGallery();
        this.initVariants();
        this.initStickyAtc();
        this.initGiftNoteTooltip();
        this.initAddToCartState();
      }

      initQuantity() {
        const minus = this.querySelector("[data-qty-minus]");
        const plus = this.querySelector("[data-qty-plus]");
        const input = this.querySelector("[data-qty-input]");
        if (!minus || !plus || !input) return;

        const clampValue = (value) => {
          const min = Number(input.min || 1);
          const max = Number(input.max || 99);
          if (Number.isNaN(value)) return min;
          return Math.min(Math.max(value, min), max);
        };

        minus.addEventListener("click", () => {
          input.value = clampValue(Number(input.value) - 1);
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });

        plus.addEventListener("click", () => {
          input.value = clampValue(Number(input.value) + 1);
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });

        const updateStickyQty = () => {
          const stickyQty = this.querySelector(".pdp-bundle__sticky-qty-value");
          if (stickyQty) {
            stickyQty.textContent = input.value;
          }
        };

        input.addEventListener("change", () => {
          input.value = clampValue(Number(input.value));
          updateStickyQty();
        });

        updateStickyQty();
      }

      initGallery() {
        const track = this.querySelector("[data-gallery-track]");
        const dots = Array.from(this.querySelectorAll(".pdp-gallery-dot"));
        const prev = this.querySelector(".pdp-gallery-prev");
        const next = this.querySelector(".pdp-gallery-next");
        if (!track) return;

        if (this.galleryState && this.galleryState.cleanup) {
          this.galleryState.cleanup();
        }

        track.querySelectorAll('[data-clone="true"]').forEach((node) => node.remove());
        delete track.dataset.infiniteReady;
        delete track.dataset.infinitePositioned;

        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        let slides = Array.from(track.querySelectorAll("[data-gallery-slide]"));
        if (slides.length === 0) return;

        const isInfinite = isMobile && slides.length > 1;
        if (isInfinite && !track.dataset.infiniteReady) {
          const firstClone = slides[0].cloneNode(true);
          const lastClone = slides[slides.length - 1].cloneNode(true);
          firstClone.setAttribute("data-clone", "true");
          lastClone.setAttribute("data-clone", "true");
          track.insertBefore(lastClone, slides[0]);
          track.appendChild(firstClone);
          track.dataset.infiniteReady = "true";
          slides = Array.from(track.querySelectorAll("[data-gallery-slide]"));
        }

        const scrollToSlideIndex = (index, behavior = "smooth") => {
          const clamped = Math.max(0, Math.min(index, slides.length - 1));
          const target = slides[clamped];
          track.scrollTo({ left: target.offsetLeft, behavior });
        };

        const scrollToIndex = (index) => {
          if (isInfinite) {
            scrollToSlideIndex(index + 1);
          } else {
            scrollToSlideIndex(index);
          }
        };

        const getNearestIndex = () => {
          const scrollLeft = track.scrollLeft;
          let nearestIndex = 0;
          let nearestDistance = Infinity;
          slides.forEach((slide, index) => {
            const distance = Math.abs(slide.offsetLeft - scrollLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });
          return nearestIndex;
        };

        const getRealIndex = (index) => {
          if (!isInfinite) return index;
          if (index === 0) return dots.length - 1;
          if (index === slides.length - 1) return 0;
          return index - 1;
        };

        const updateDots = () => {
          if (dots.length === 0) return;
          const activeIndex = getRealIndex(getNearestIndex());
          dots.forEach((dot, index) => {
            dot.classList.toggle("is-active", index === activeIndex);
            dot.setAttribute("aria-current", index === activeIndex ? "true" : "false");
          });
        };

        if (isInfinite && !track.dataset.infinitePositioned) {
          scrollToSlideIndex(1, "auto");
          track.dataset.infinitePositioned = "true";
        }

        const onPrevClick = () => {
          const currentIndex = dots.findIndex((dot) => dot.classList.contains("is-active"));
          const index = currentIndex === -1 ? 0 : currentIndex;
          if (isInfinite && index === 0) {
            scrollToSlideIndex(0);
          } else {
            scrollToIndex(index - 1);
          }
        };

        const onNextClick = () => {
          const currentIndex = dots.findIndex((dot) => dot.classList.contains("is-active"));
          const index = currentIndex === -1 ? 0 : currentIndex;
          if (isInfinite && index === dots.length - 1) {
            scrollToSlideIndex(slides.length - 1);
          } else {
            scrollToIndex(index + 1);
          }
        };

        if (prev && next) {
          prev.addEventListener("click", onPrevClick);
          next.addEventListener("click", onNextClick);
        }

        const dotHandlers = [];
        dots.forEach((dot, index) => {
          const handler = () => scrollToIndex(index);
          dotHandlers.push({ dot, handler });
          dot.addEventListener("click", handler);
        });

        let scrollEndTimer;
        const onScroll = () => {
          window.requestAnimationFrame(updateDots);
          if (!isInfinite) return;
          clearTimeout(scrollEndTimer);
          scrollEndTimer = setTimeout(() => {
            const nearest = getNearestIndex();
            if (nearest === 0) {
              scrollToSlideIndex(slides.length - 2, "auto");
            } else if (nearest === slides.length - 1) {
              scrollToSlideIndex(1, "auto");
            }
          }, 80);
        };

        track.addEventListener("scroll", onScroll);

        const onResize = () => {
          const nowMobile = window.matchMedia("(max-width: 767px)").matches;
          if (nowMobile !== isMobile) {
            this.initGallery();
            return;
          }
          updateDots();
        };

        window.addEventListener("resize", onResize);
        updateDots();

        this.galleryState = {
          cleanup: () => {
            if (prev && next) {
              prev.removeEventListener("click", onPrevClick);
              next.removeEventListener("click", onNextClick);
            }
            dotHandlers.forEach(({ dot, handler }) => {
              dot.removeEventListener("click", handler);
            });
            track.removeEventListener("scroll", onScroll);
            window.removeEventListener("resize", onResize);
          }
        };
      }

      initVariants() {
        const variantInput = this.querySelector('input[name="id"]');
        const priceDisplay = this.querySelector('.pdp-bundle__price-current');
        const compareDisplay = this.querySelector('.pdp-bundle__price-compare');
        const discountTag = this.querySelector('.pdp-bundle__tag--discount');
        const addButtons = Array.from(this.querySelectorAll('.pdp-bundle__add'));
        const buyNowButtons = Array.from(this.querySelectorAll('.pdp-bundle__buy-now, .product-page--buy-now'));
        const buyNowErrorNodes = Array.from(this.querySelectorAll('.product-page--buy-now-error'));
        const giftNote = this.querySelector('.pdp-bundle__giftnote');
        const paymentBtn = this.querySelector('.pdp-bundle__payment');
        const stickyVariant = this.querySelector('[data-sticky-variant]');

        const updateVariantState = (selected) => {
          if (!selected) return;

          const variantId = selected.dataset.variantId;
          const variantPrice = selected.dataset.variantPrice;
          const variantComparePrice = selected.dataset.variantComparePrice;
          const variantOriginalPrice = selected.dataset.variantOriginalPrice;
          const hasComparePrice = selected.dataset.hasComparePrice;
          const hasDynamicPricing = selected.dataset.hasDynamicPricing === 'true';
          const discountLabel = selected.dataset.variantDiscountLabel || '';
          const isAvailable = selected.dataset.variantAvailable === 'true';
          const isFakeOos = selected.dataset.fakeOos === 'true';
          const isAvailableEffective = isAvailable && !isFakeOos;

          if (variantInput && variantId) {
            variantInput.value = variantId;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
            variantInput.dispatchEvent(new Event('input', { bubbles: true }));
          }

          if (priceDisplay && variantPrice) {
            priceDisplay.textContent = variantPrice;
          }

          if (compareDisplay) {
            if (hasComparePrice && hasComparePrice !== '0') {
              compareDisplay.textContent = variantComparePrice || '';
              compareDisplay.style.display = '';
            } else if (hasDynamicPricing) {
              compareDisplay.textContent = variantOriginalPrice || '';
              compareDisplay.style.display = '';
            } else {
              compareDisplay.style.display = 'none';
            }
          }

          if (discountTag) {
            if (discountLabel) {
              discountTag.textContent = `${discountLabel} off`;
              discountTag.style.display = '';
            } else {
              discountTag.style.display = 'none';
            }
          }

          addButtons.forEach((btn) => {
            if (isAvailableEffective) {
              btn.classList.remove('out-of-stock');
              btn.removeAttribute('disabled');
              btn.textContent = btn.dataset.addLabel || 'Add to cart';
            } else {
              btn.classList.add('out-of-stock');
              btn.setAttribute('disabled', 'disabled');
              btn.textContent = btn.dataset.outLabel || 'Out of stock';
            }
          });

          buyNowButtons.forEach((btn) => {
            const buyNowTextNode = btn.querySelector('.buy-now__text');
            const defaultBuyNowText = btn.getAttribute('data-buy-now-text') || 'Buy Now';

            if (isAvailableEffective) {
              btn.classList.remove('out-of-stock', 'sold-out', 'is-loading');
              btn.removeAttribute('disabled');
              btn.setAttribute('aria-busy', 'false');
              btn.hidden = false;
              btn.style.removeProperty('display');
              if (buyNowTextNode) {
                buyNowTextNode.textContent = defaultBuyNowText;
              }
            } else {
              btn.classList.remove('is-loading');
              btn.classList.add('out-of-stock', 'sold-out');
              btn.setAttribute('disabled', 'disabled');
              btn.setAttribute('aria-busy', 'false');
              btn.hidden = true;
              btn.style.display = 'none';
              if (buyNowTextNode) {
                buyNowTextNode.textContent = defaultBuyNowText;
              }
            }
          });

          if (isAvailableEffective && buyNowErrorNodes.length) {
            buyNowErrorNodes.forEach((errorNode) => {
              errorNode.textContent = '';
            });
          }

          if (giftNote) {
            giftNote.style.display = isAvailableEffective ? '' : 'none';
          }

          if (paymentBtn) {
            paymentBtn.style.display = isAvailableEffective ? '' : 'none';
          }

          if (stickyVariant) {
            const title = selected.dataset.variantTitle || '';
            stickyVariant.textContent = title === 'Default Title' ? '' : title;
          }
        };

        const dropdown = this.querySelector('.product-variants-dropdown');
        if (dropdown) {
          const toggle = dropdown.querySelector('.variant-dropdown-toggle');
          const options = dropdown.querySelector('.variant-dropdown-options');
          const optionItems = dropdown.querySelectorAll('.variant-dropdown-option');

          if (toggle && options && !toggle.dataset.dropdownToggleBound) {
            toggle.addEventListener('click', (event) => {
              event.stopPropagation();
              options.classList.toggle('show');
            });
            toggle.dataset.dropdownToggleBound = 'true';
          }

          optionItems.forEach((option) => {
            option.addEventListener('click', (event) => {
              event.preventDefault();
              optionItems.forEach((item) => item.classList.remove('active'));
              option.classList.add('active');
              if (toggle) {
                toggle.textContent = option.dataset.variantTitle || option.textContent.trim();
              }
              options.classList.remove('show');
              updateVariantState(option);
            });
          });

          if (!dropdown.dataset.outsideClickBound) {
            document.addEventListener('click', (event) => {
              if (dropdown && !dropdown.contains(event.target)) {
                options.classList.remove('show');
              }
            });
            dropdown.dataset.outsideClickBound = 'true';
          }
        }

        const variantButtons = this.querySelector('.product-variants-buttons');
        if (variantButtons) {
          const buttonCards = variantButtons.querySelectorAll('.variant-button-card');
          buttonCards.forEach((card) => {
            card.addEventListener('click', () => {
              buttonCards.forEach((btn) => btn.classList.remove('active'));
              card.classList.add('active');
              updateVariantState(card);
            });
          });
        }

        const activeOption = this.querySelector('.variant-button-card.active') || this.querySelector('.variant-dropdown-option.active');
        if (activeOption) {
          updateVariantState(activeOption);
        }
      }

      initStickyAtc() {
        const sticky = this.querySelector('[data-sticky]');
        const ctaWrap = this.querySelector('.pdp-bundle__cta-wrap');
        const footer = document.querySelector('.main-footer');

        if (!sticky || !ctaWrap || sticky.dataset.stickyInit === 'true') return;
        sticky.dataset.stickyInit = 'true';

        const toggleSticky = () => {
          if (window.innerWidth > 767) {
            sticky.classList.remove('is-visible');
            return;
          }

          const ctaBottom = ctaWrap.getBoundingClientRect().bottom + window.scrollY;
          const scrollY = window.scrollY;
          const windowHeight = window.innerHeight;
          const bottomY = scrollY + windowHeight;
          const footerTop = footer ? footer.getBoundingClientRect().top + window.scrollY : Infinity;

          if (scrollY > ctaBottom && bottomY < footerTop) {
            sticky.classList.add('is-visible');
          } else {
            sticky.classList.remove('is-visible');
          }
        };

        window.addEventListener('scroll', toggleSticky);
        window.addEventListener('resize', toggleSticky);
        toggleSticky();
      }

      initGiftNoteTooltip() {
        const text = this.querySelector(".pdp-bundle__gift-text");
        const tooltip = this.querySelector(".pdp-bundle__gift-tooltip");
        const trigger = this.querySelector(".pdp-bundle__giftnote-trigger");
        if (!text || !tooltip || !trigger) return;

        const gap = 20;
        const placeTooltip = () => {
          const textRect = text.getBoundingClientRect();
          const triggerRect = trigger.getBoundingClientRect();
          const top = textRect.bottom - triggerRect.top + gap;
          tooltip.style.top = `${top}px`;
        };

        const show = () => {
          placeTooltip();
          tooltip.style.opacity = "1";
        };

        const hide = () => {
          tooltip.style.opacity = "0";
        };

        text.addEventListener("mouseenter", show);
        text.addEventListener("mouseleave", hide);
        text.addEventListener("focus", show);
        text.addEventListener("blur", hide);
        window.addEventListener("resize", () => {
          if (tooltip.style.opacity === "1") {
            placeTooltip();
          }
        });
      }

      initAddToCartState() {
        const form = this.querySelector("form");
        const buttons = Array.from(this.querySelectorAll(".pdp-bundle__add"));
        if (!form || buttons.length === 0) return;

        const resetAddButtons = () => {
          document.querySelectorAll(".pdp-bundle__add.is-adding").forEach((btn) => {
            btn.textContent = btn.dataset.addLabel || "Add to Cart";
            btn.classList.remove("is-adding");
            btn.removeAttribute("disabled");
          });
        };

        form.addEventListener("submit", () => {
          buttons.forEach((btn) => {
            if (btn.hasAttribute("disabled")) return;
            btn.textContent = btn.dataset.addingLabel || "Adding...";
            btn.setAttribute("disabled", "disabled");
            btn.classList.add("is-adding");
          });
        });

        if (!window.__pdpBundleCartHooks) {
          window.__pdpBundleCartHooks = true;

          document.addEventListener("cart:updated", resetAddButtons);
          document.addEventListener("cart:refresh", resetAddButtons);
          document.addEventListener("cart:change", resetAddButtons);
          document.addEventListener("rebuy:cart:updated", resetAddButtons);
          document.addEventListener("rebuy:cart:open", resetAddButtons);

          const shouldResetForUrl = (url) => {
            if (!url) return false;
            return url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update");
          };

          const originalFetch = window.fetch;
          if (originalFetch && !window.__pdpBundleFetchPatched) {
            window.__pdpBundleFetchPatched = true;
            window.fetch = (...args) => {
              const responsePromise = originalFetch.apply(window, args);
              const requestUrl = typeof args[0] === "string" ? args[0] : args[0]?.url;
              if (shouldResetForUrl(requestUrl)) {
                responsePromise.then((response) => {
                  if (response && response.ok) {
                    resetAddButtons();
                  }
                }).catch(() => {});
              }
              return responsePromise;
            };
          }

          if (!window.__pdpBundleXhrPatched) {
            window.__pdpBundleXhrPatched = true;
            const originalOpen = XMLHttpRequest.prototype.open;
            const originalSend = XMLHttpRequest.prototype.send;

            XMLHttpRequest.prototype.open = function(method, url, ...rest) {
              this.__pdpBundleUrl = url;
              return originalOpen.call(this, method, url, ...rest);
            };

            XMLHttpRequest.prototype.send = function(body) {
              this.addEventListener("load", () => {
                if (shouldResetForUrl(this.__pdpBundleUrl) && this.status >= 200 && this.status < 300) {
                  resetAddButtons();
                }
              });
              return originalSend.call(this, body);
            };
          }
        }
      }
    }

    customElements.define("pdp-bundle", PdpBundle);
  }

  (function() {
    let modal = null;
    let modalRoot = null;
    let currentIndex = 0;
    let mediaItems = [];
    let triggerHandlers = [];

    function initModal() {
      modal = document.getElementById('mila-media-modal');
      if (!modal) {
        return;
      }
      modalRoot = modal.closest('pdp-bundle');

      const overlay = modal.querySelector('.mila-media-modal__overlay');
      const closeBtn = modal.querySelector('.mila-media-modal__close');
      const prevBtn = modal.querySelector('.mila-media-modal__nav--prev');
      const nextBtn = modal.querySelector('.mila-media-modal__nav--next');
      const imageEl = modal.querySelector('.mila-media-modal__image');
      const videoEl = modal.querySelector('.mila-media-modal__video');

      collectMediaItems(modalRoot);

      if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          closeModal();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          showPrev();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          showNext();
        });
      }

      if (overlay) {
        overlay.addEventListener('click', function(e) {
          if (e.target === overlay) {
            closeModal();
          }
        });
      }

      document.addEventListener('keydown', function(e) {
        if (!modal || !modal.classList.contains('is-open')) return;

        if (e.key === 'Escape') {
          e.preventDefault();
          closeModal();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          showPrev();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          showNext();
        }
      });

      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let touchEndY = 0;
      const minSwipeDistance = 50;

      const content = modal.querySelector('.mila-media-modal__content');
      if (content) {
        content.addEventListener('touchstart', function(e) {
          if (!modal || !modal.classList.contains('is-open')) return;
          touchStartX = e.changedTouches[0].screenX;
          touchStartY = e.changedTouches[0].screenY;
        }, { passive: true });

        content.addEventListener('touchend', function(e) {
          if (!modal || !modal.classList.contains('is-open')) return;
          touchEndX = e.changedTouches[0].screenX;
          touchEndY = e.changedTouches[0].screenY;

          const deltaX = touchEndX - touchStartX;
          const deltaY = touchEndY - touchStartY;
          const absDeltaX = Math.abs(deltaX);
          const absDeltaY = Math.abs(deltaY);

          if (absDeltaX > absDeltaY && absDeltaX > minSwipeDistance) {
            e.preventDefault();

            if (deltaX > 0) {
              showPrev();
            } else {
              showNext();
            }
          }
        }, { passive: false });
      }

      initTriggers();
    }

    function collectMediaItems(root) {
      mediaItems = [];

      const gallerySlider = root ? root.querySelector('.pdp-gallery-slider') : document.querySelector('.pdp-gallery-slider');
      if (!gallerySlider) {
        return;
      }

      const mediaContainers = gallerySlider.querySelectorAll('.image-box');

      mediaContainers.forEach(function(container, index) {
        const img = container.querySelector('img.mila-media-modal__trigger');
        const video = container.querySelector('video');

        if (img) {
          mediaItems.push({
            type: 'image',
            id: img.dataset.mediaId,
            src: img.dataset.mediaSrc || img.src,
            alt: img.dataset.mediaAlt || img.alt || '',
            element: img
          });
        } else if (video) {
          const videoSource = video.querySelector('source');
          const videoSrc = videoSource ? videoSource.src : (video.src || '');
          mediaItems.push({
            type: 'video',
            id: video.id || 'video-' + index,
            src: videoSrc,
            alt: video.alt || '',
            element: video
          });
        }
      });
    }

    function initTriggers() {
      if (window.milaMediaModalDelegationHandler) {
        document.removeEventListener('click', window.milaMediaModalDelegationHandler, true);
      }

      window.milaMediaModalDelegationHandler = function(e) {
        const clickedEl = e.target;
        if (!clickedEl || !clickedEl.classList.contains('mila-media-modal__trigger')) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const clickedRoot = clickedEl.closest('pdp-bundle');
        if (clickedRoot) {
          modalRoot = clickedRoot;
          modal = clickedRoot.querySelector('.mila-media-modal');
        }
        if (!modal) {
          modal = document.getElementById('mila-media-modal');
        }
        collectMediaItems(modalRoot);

        const clickedMediaId = clickedEl.dataset.mediaId;
        if (!clickedMediaId) {
          return;
        }

        let mediaIndex = -1;
        for (let i = 0; i < mediaItems.length; i++) {
          if (mediaItems[i].type === 'image' && mediaItems[i].id === clickedMediaId) {
            mediaIndex = i;
            break;
          }
        }

        if (mediaIndex === -1) {
          return;
        }

        if (modal) {
          openModal(mediaIndex);
        }
      };

      document.addEventListener('click', window.milaMediaModalDelegationHandler, true);

      const triggers = document.querySelectorAll('.mila-media-modal__trigger');
      triggers.forEach(function(trigger) {
        trigger.onclick = null;
        trigger.removeAttribute('onclick');
      });
    }

    function openModal(index) {
      if (!modal) {
        modal = document.getElementById('mila-media-modal');
        if (!modal) {
          return;
        }
        modalRoot = modal.closest('pdp-bundle');
      }

      if (mediaItems.length === 0) {
        return;
      }

      currentIndex = index || 0;
      updateImage();

      modal.classList.add('is-open');
      modal.removeAttribute('style');
      modal.style.display = 'block';

      document.body.style.overflow = 'hidden';
      updateNavButtons();

      positionButtonsOnMobile();
    }

    function positionButtonsOnMobile() {
      if (window.innerWidth > 767) {
        return;
      }

      const content = modal.querySelector('.mila-media-modal__content');
      const prevBtn = modal.querySelector('.mila-media-modal__nav--prev');
      const nextBtn = modal.querySelector('.mila-media-modal__nav--next');

      if (!content || !prevBtn || !nextBtn) {
        return;
      }

      function calculateButtonPosition() {
        if (window.innerWidth > 767) {
          prevBtn.style.top = '';
          nextBtn.style.top = '';
          return;
        }

        const container = modal.querySelector('.mila-media-modal__container');
        if (!container) return;

        const contentRect = content.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        const contentBottomRelative = contentRect.bottom - containerRect.top;

        const gapFromMedia = 24;
        const buttonTop = contentBottomRelative + gapFromMedia;

        prevBtn.style.top = buttonTop + 'px';
        nextBtn.style.top = buttonTop + 'px';
      }

      setTimeout(calculateButtonPosition, 50);

      let resizeTimeout;
      const resizeHandler = function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(calculateButtonPosition, 100);
      };

      if (!window.milaModalButtonResizeHandler) {
        window.milaModalButtonResizeHandler = resizeHandler;
        window.addEventListener('resize', resizeHandler);
      }

      window.addEventListener('orientationchange', function() {
        setTimeout(calculateButtonPosition, 200);
      });
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }

    function showPrev() {
      if (mediaItems.length === 0) return;
      currentIndex = (currentIndex - 1 + mediaItems.length) % mediaItems.length;
      updateImage();
      updateNavButtons();
    }

    function showNext() {
      if (mediaItems.length === 0) return;
      currentIndex = (currentIndex + 1) % mediaItems.length;
      updateImage();
      updateNavButtons();
    }

    let pendingImageToken = 0;
    const transparentPixel = 'data:image/gif;base64,R0lGODlhAQABAAAAACw=';
    function preloadImage(src, done) {
      if (!src) {
        done(false);
        return;
      }
      const img = new Image();
      img.onload = function() {
        done(true);
      };
      img.onerror = function() {
        done(false);
      };
      img.src = src;
    }

    function updateImage() {
      const item = mediaItems[currentIndex];

      if (!modal) return;
      const imageEl = modal.querySelector('.mila-media-modal__image');
      const videoEl = modal.querySelector('.mila-media-modal__video');

      if (!item) {
        return;
      }

      if (imageEl) imageEl.style.display = 'none';
      if (videoEl) {
        videoEl.style.display = 'none';
        videoEl.pause();
        videoEl.currentTime = 0;
      }

      if (item.type === 'video') {
        if (videoEl) {
          const videoSource = videoEl.querySelector('source');
          if (videoSource) {
            videoSource.src = item.src;
          } else {
            videoEl.src = item.src;
          }
          videoEl.load();
          videoEl.style.display = 'block';
        }
      } else {
        if (imageEl) {
          const token = ++pendingImageToken;
          imageEl.alt = '';
          imageEl.setAttribute('aria-label', item.alt || '');
          imageEl.style.display = 'block';
          imageEl.style.opacity = '0';
          imageEl.style.visibility = 'hidden';
          imageEl.src = transparentPixel;
          preloadImage(item.src, function(success) {
            if (token !== pendingImageToken) return;
            if (!success) {
              imageEl.style.visibility = 'visible';
              imageEl.style.opacity = '1';
              return;
            }
            imageEl.onload = function() {
              if (token !== pendingImageToken) return;
              imageEl.style.visibility = 'visible';
              requestAnimationFrame(function() {
                imageEl.style.opacity = '1';
              });
            };
            imageEl.src = item.src;
          });
        }
      }
    }

    function updateNavButtons() {
      if (!modal) return;
      const prevBtn = modal.querySelector('.mila-media-modal__nav--prev');
      const nextBtn = modal.querySelector('.mila-media-modal__nav--next');

      if (!prevBtn || !nextBtn) return;

      if (mediaItems.length <= 1) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
      } else {
        prevBtn.style.display = 'flex';
        nextBtn.style.display = 'flex';
      }
    }

    function refreshModal() {
      collectMediaItems(modalRoot);
      initTriggers();
    }

    function init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initModal);
      } else {
        initModal();
      }
    }

    init();

    let variantChangeTimeout;
    document.addEventListener('variant:change', function() {
      clearTimeout(variantChangeTimeout);
      variantChangeTimeout = setTimeout(function() {
        refreshModal();
      }, 100);
    });

    const variantProductFamily = document.querySelector('.variant-product-family');
    if (variantProductFamily) {
      const galleryObserver = new MutationObserver(function(mutations) {
        let galleryChanged = false;
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' && mutation.target.classList.contains('pdp-gallery-slider')) {
            galleryChanged = true;
          }
        });

        if (galleryChanged) {
          setTimeout(function() {
            refreshModal();
          }, 200);
        }
      });

      const gallerySlider = document.querySelector('.pdp-gallery-slider');
      if (gallerySlider) {
        galleryObserver.observe(gallerySlider, {
          childList: true,
          subtree: true
        });
      }

      document.addEventListener('click', function(e) {
        const card = e.target.closest('.variant-product-family-card, .variant-dropdown-item');
        if (card && !card.classList.contains('active')) {
          setTimeout(function() {
            refreshModal();
          }, 300);
        }
      });
    }

    window.milaMediaModal = {
      open: openModal,
      close: closeModal,
      refresh: refreshModal
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["potstickers-comparison-chart"] && !Shopify.designMode) return;
  try {
    
    
    var scrollToTopBtn = document.querySelector(".comparison_chart .table table tr:last-child td:nth-child(2)")
    var rootElement = document.documentElement
    
    function handleScroll() {
      var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight
    }
    
    function scrollToTop() {
      rootElement.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }
    scrollToTopBtn.addEventListener("click", scrollToTop)
    document.addEventListener("scroll", handleScroll);
    
    
    
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products--with-options"] && !Shopify.designMode) return;
  try {
    
 (function () {
  if($('.option-variants').length>0){
   $('.option-variants .radios--input').change(function(){
    let new_id = $(this).val();
    $(this).closest('form').find('input[name="product-variant-id"]').val(new_id);
   });
  }
 })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soup-dumplings-comparison-chart"] && !Shopify.designMode) return;
  try {
    

var scrollToTopBtn = document.querySelector(".comparison_chart .table table tr:last-child td:nth-child(2)")
var rootElement = document.documentElement

function handleScroll() {
  var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight
}

function scrollToTop() {
  rootElement.scrollTo({
    top: 0,
    behavior: "smooth"
  })
}
scrollToTopBtn.addEventListener("click", scrollToTop)
document.addEventListener("scroll", handleScroll);




  } catch(e) { console.error(e); }
})();
})();
